import React from 'react';
import { Container, Input, ErrorText } from './styles';

export default ({
    style,
    placeholder,
    value,
    onChange,
    onSearch,
    onBlur,
    error,
}) => {
    return (
        <Container style={style}>
            <Input
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onSearch={onSearch}
                onBlur={onBlur}
                error={error}
                size={"large"}
                bordered={false}
                enterButton
                allowClear
            />
            {error && <ErrorText>{error}</ErrorText>}
        </Container>
    );
};